import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-charter',
  templateUrl: './charter.component.html',
  styleUrls: ['./charter.component.css'],
})
export class CharterComponent implements OnInit {
  pdfUrl = 'assets/charter/telone-client-service-charter.pdf'; // Use a static path to avoid CORS
  // pdfUrl: string = 'http://localhost:3000/api/pdf/charter.pdf'
  pdfDocument: any;
  imageSrc = 'assets/charter/telone-client-service-charter.jpg'; // High-res for desktop
  imageSrcMobile = 'assets/charter/telone-client-service-charter.jpg'; // Mobile optimized version

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {}

  get pdfApiUrl(): string {
    return this.pdfUrl;
  }
}
